import React from 'react';
import PropTypes from 'prop-types';

export const EmptyChats = ({ width, height, ...props }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 151 109'
    { ...props }
  >
    <path
      fill='#FFF7EB'
      d='M74.793 107c29.547 0 53.5-23.953 53.5-53.5S104.34 0 74.793 0s-53.5 23.953-53.5 53.5 23.953 53.5 53.5 53.5Z'
    />
    <path
      fill='#FFE7C4'
      d='M119.609 36.206 73.764 68.201 27.918 36.206l41.968-29.3a6.784 6.784 0 0 1 7.76 0l8.37 5.852 2.192 1.522 22.071 15.412 2.325 1.632 7.005 4.882Z'
    />
    <path
      fill='#FFD89D'
      d='M66.31 62.999 27.917 90.298V36.206L66.309 63Z'
    />
    <g filter='url(#a)'>
      <ellipse
        cx={ 96.163 }
        cy={ 35.138 }
        fill='#FF4C77'
        fillOpacity={ 0.3 }
        rx={ 17.061 }
        ry={ 5.484 }
      />
    </g>
    <path
      fill='#FFD89D'
      d='m81.223 62.999 38.391 27.299V36.206L81.223 63Z'
    />
    <path
      fill='#FFB84E'
      d='m27.918 90.298 41.919-29.803a6.773 6.773 0 0 1 7.858 0l41.914 29.803H27.918Z'
    />
    <g filter='url(#b)'>
      <path
        fill='#FFC876'
        d='M32.76 26.404a66.063 66.063 0 0 1-22.311 5.98c1.044 2.428 8.466 14.582 30.499 24.597.595.092 14.353-6.309 21.904-10.698-.257.367-23.453-8.168-30.091-19.879Z'
      />
    </g>
    <path
      fill='#B16900'
      d='M33.304 32.448a1.262 1.262 0 0 0-1.108-.164L19.9 36.262a.654.654 0 0 0-.3 1.041.9.9 0 0 0 .981.275l12.611-4.32a.459.459 0 0 0 .113-.81ZM33.089 37.348a1.16 1.16 0 0 0-1.165-.254l-8.513 2.865a.565.565 0 0 0-.256.895c.205.25.544.346.85.242l8.931-3.041a.422.422 0 0 0 .153-.707ZM37.661 39.774a1.195 1.195 0 0 0-1.155-.19L26.7 43.147a.57.57 0 0 0-.22.927.783.783 0 0 0 .84.197l10.22-3.75a.435.435 0 0 0 .121-.747ZM41.09 47.13a1.09 1.09 0 0 0-1.196-.287l-5.604 2.139a.557.557 0 0 0-.25.85c.206.278.571.384.893.26l6.007-2.327c.259-.1.337-.429.15-.635Z'
    />
    <g filter='url(#c)'>
      <path
        fill='#FFC876'
        d='M114.007 43.355a80.104 80.104 0 0 0 27.054 7.25c-1.267 2.944-10.266 17.682-36.982 29.826-.722.111-17.404-7.65-26.56-12.972.312.445 28.438-9.905 36.488-24.104Z'
      />
    </g>
    <path
      fill='#B16900'
      d='M113.348 50.683a1.53 1.53 0 0 1 1.343-.199l14.91 4.824c.535.173.725.831.366 1.262-.29.348-.764.48-1.191.334l-15.292-5.238a.556.556 0 0 1-.136-.983ZM109.172 54.654a1.408 1.408 0 0 1 1.413-.308l10.322 3.474a.685.685 0 0 1 .311 1.085.943.943 0 0 1-1.032.294l-10.828-3.687a.512.512 0 0 1-.186-.858ZM104.882 57.95a1.45 1.45 0 0 1 1.401-.23l11.89 4.32a.69.69 0 0 1 .267 1.124.95.95 0 0 1-1.018.24l-12.392-4.548a.527.527 0 0 1-.148-.906ZM95.23 64.545a1.321 1.321 0 0 1 1.45-.347l6.796 2.593c.417.159.568.672.302 1.031a.928.928 0 0 1-1.082.315l-7.283-2.821a.48.48 0 0 1-.183-.77ZM99.664 61.023a1.537 1.537 0 0 1 1.344-.141l15.657 5.725a.7.7 0 0 1 .221 1.186.964.964 0 0 1-.967.178l-16.151-5.95a.559.559 0 0 1-.104-.998ZM44.48 41.382a1.268 1.268 0 0 0-1.11-.117l-12.912 4.721a.578.578 0 0 0-.181.978.795.795 0 0 0 .797.148l13.32-4.907a.46.46 0 0 0 .086-.823Z'
    />
    <defs>
      <filter
        id='a'
        width={ 77.667 }
        height={ 54.514 }
        x={ 57.329 }
        y={ 7.881 }
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood
          floodOpacity={ 0 }
          result='BackgroundImageFix'
        />
        <feBlend
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feGaussianBlur
          result='effect1_foregroundBlur_4753_280507'
          stdDeviation={ 10.886 }
        />
      </filter>
      <filter
        id='b'
        width={ 73.304 }
        height={ 51.48 }
        x={ -0.002 }
        y={ 19.437 }
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood
          floodOpacity={ 0 }
          result='BackgroundImageFix'
        />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy={ 3.484 } />
        <feGaussianBlur
          stdDeviation={ 5.226 }
        />
        <feComposite
          in2='hardAlpha'
          operator='out'
        />
        <feColorMatrix values='0 0 0 0 0.0196078 0 0 0 0 0.168627 0 0 0 0 0.396078 0 0 0 0.15 0' />
        <feBlend
          in2='BackgroundImageFix'
          result='effect1_dropShadow_4753_280507'
        />
        <feBlend
          in='SourceGraphic'
          in2='effect1_dropShadow_4753_280507'
          result='shape'
        />
      </filter>
      <filter
        id='c'
        width={ 93.154 }
        height={ 66.689 }
        x={ 57.434 }
        y={ 41.613 }
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood
          floodOpacity={ 0 }
          result='BackgroundImageFix'
        />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset
          dx={ -5.28 }
          dy={ 13.064 }
        />
        <feGaussianBlur
          stdDeviation={ 7.403 }
        />
        <feComposite
          in2='hardAlpha'
          operator='out'
        />
        <feColorMatrix values='0 0 0 0 0.021441 0 0 0 0 0.168056 0 0 0 0 0.395833 0 0 0 0.15 0' />
        <feBlend
          in2='BackgroundImageFix'
          result='effect1_dropShadow_4753_280507'
        />
        <feBlend
          in='SourceGraphic'
          in2='effect1_dropShadow_4753_280507'
          result='shape'
        />
      </filter>
    </defs>
  </svg>
);

EmptyChats.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

EmptyChats.defaultProps = {
  width: 130,
  height: 107,
};
